import React from "react";
import "../printStyles.css";

function VehicleDefectReportForm() {
  return (
    <>
      {/* CSS for print functionality to hide everything but the form */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            #VehicleDefectReportForm, #VehicleDefectReportForm * {
              visibility: visible;
            }
            #VehicleDefectReportForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="VehicleDefectReportForm" className="p-4 border rounded-lg bg-white shadow-md font-sans">
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">Vehicle Defect Report Form</h3>

        <form>
          {/* Reported By (Name) */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="reportedBy">
              Reported By (Name):
            </label>
            <input
              type="text"
              id="reportedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="vehicleRegistration">
              Vehicle Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter vehicle registration"
            />
          </div>

          {/* Date of Report */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="dateOfReport">
              Date of Report:
            </label>
            <input
              type="date"
              id="dateOfReport"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Defect Status */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="defectStatus">
              Defect Status:
            </label>
            <div className="flex space-x-4 mt-2">
              <label className="flex items-center space-x-1">
                <input type="radio" name="defectStatus" value="Minor" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Minor</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="defectStatus" value="Major" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Major (V.O.R.)</span>
              </label>
            </div>
          </div>

          {/* Description of Defect */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="defectDescription">
              Description of Defect:
            </label>
            <textarea
              id="defectDescription"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the defect in detail..."
            />
          </div>

          {/* Action Taken */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="actionTaken">
              Action Taken:
            </label>
            <div className="flex space-x-4 mt-2">
              <label className="flex items-center space-x-1">
                <input type="radio" name="actionTaken" value="Repair" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Repair</span>
              </label>
              <label className="flex items-center space-x-1">
                <input type="radio" name="actionTaken" value="Replaced" className="form-radio text-blue-500 h-4 w-4" />
                <span className="text-sm">Replaced</span>
              </label>
            </div>
          </div>

          {/* Repair Completed By */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="repairCompletedBy">
              Repair Completed By (Name):
            </label>
            <input
              type="text"
              id="repairCompletedBy"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter name"
            />
          </div>

          {/* Date of Repair */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="dateOfRepair">
              Date of Repair:
            </label>
            <input
              type="date"
              id="dateOfRepair"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Repair Details */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="repairDetails">
              Repair Details:
            </label>
            <textarea
              id="repairDetails"
              className="p-3 border border-gray-300 rounded-lg w-full h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Describe the repair that was carried out..."
            />
          </div>

          {/* Manager Sign-off */}
          <div className="mb-4">
            <label className="block text-lg font-medium text-gray-700" htmlFor="managerSignOff">
              Manager Sign-off:
            </label>
            <input
              type="text"
              id="managerSignOff"
              className="p-3 border border-gray-300 rounded-lg w-full md:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Manager's name"
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default VehicleDefectReportForm;
